import { loaderService } from "../../../common/custom-loader/loader-service";
import { GET_LIST_POSSIBLE_ROUTES, VIEW_ALL_TRANSPORTER_MAPPED_DETAILS, EDIT_RESOURCE_STAKEHOLDER_MAPPING, ALL_TRANSPORTER_NAME, FROM_TO_TRANSPORTER_DROPDOWN, SAVE_MULTIPLE_RESOURCE_STAKEHOLDER_MAPPING } from '../../../common/URLs';

import { getLocalStorageItem } from "../../../common/localStorageUtils";
import apiClient from "../../../axios";

export function getAllRoutes(setChooseTransRoute) {
  loaderService.showLoader();
  apiClient
    .post(GET_LIST_POSSIBLE_ROUTES,
      {
        "serviceType": "transporter"
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        },
      }
    )
    .then((response) => {
      setChooseTransRoute(response.data.PossibleRouteDropDown);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}
export function viewAllMappedTransporter(selectedroute, setViewAllTransporterDetails, setCheckData) {
  loaderService.showLoader();
  apiClient
    .post(VIEW_ALL_TRANSPORTER_MAPPED_DETAILS,
      {
        "route": selectedroute
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        },
      }
    )
    .then((response) => {
      setViewAllTransporterDetails(response);
      setCheckData(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}
export function DeleteDeactiveEditTransporterMapping(editTransDetails, deactivestatus, setMappingResponseDetails, details) {
  loaderService.showLoader();
  apiClient
    .post(EDIT_RESOURCE_STAKEHOLDER_MAPPING,
      {
        "route": details.mappingRoute,
        "transporterUrn": editTransDetails.transporterUrn,
        "sourceStakeholderUrn": editTransDetails.sourceStakeholderUrn,
        "targetStakeholderUrn": editTransDetails.targetStakeholderUrn,
        "id": editTransDetails.deactiveid ? editTransDetails.deactiveid : editTransDetails.deleteid,
        "delete": editTransDetails.deleteid ? "Y" : "N",
        "deactivate": deactivestatus ? deactivestatus : "N",
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        },
      }
    )
    .then((response) => {
      setMappingResponseDetails(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}
export function getAllTransporterName(settransporterDetails) {
  loaderService.showLoader();
  apiClient
    .post(ALL_TRANSPORTER_NAME,
      {
        "district": "",
        "state": "",
        "type": "transporter"
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        },
      }
    )
    .then((response) => {
      settransporterDetails(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}
export function getFromToTransporterDropdown(selectedTransporterUrn, selectedMappedFromUrn, setFromDropdownTransporter, setToDropdownTransporter, details) {
  loaderService.showLoader();
  apiClient
    .post(FROM_TO_TRANSPORTER_DROPDOWN,
      {
        "district": "",
        "state": "",
        "type": "",
        "route": details.transMappingRoute,
        "urn": selectedTransporterUrn,
        "fromUrn": selectedMappedFromUrn ? selectedMappedFromUrn : "",
        "fetchTo": selectedMappedFromUrn ? "Y" : "N"
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        },
      }
    )
    .then((response) => {
      response.data.from ? setFromDropdownTransporter(response.data.from) : setFromDropdownTransporter([])
      response.data.to ? setToDropdownTransporter(response.data.to) : setToDropdownTransporter([])
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}
export function submitStakeHolderMapping(multipleMappingDetails, setSaveMappingData) {
  loaderService.showLoader();
  apiClient
    .post(SAVE_MULTIPLE_RESOURCE_STAKEHOLDER_MAPPING,
      {
        "requestData": multipleMappingDetails
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setSaveMappingData(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}